
Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.FieldsRender = (function () {

    function FieldsRender(scope) {

        var getMonetField = function(type, value, options) {

            if ( options) {
                options.label = '';
                options.type = type;
            } else {
                options = {
                    label: '',
                    type: type
                };
            }

            var field = new Monet.UI.Fields.Render(options, 'TextFileLayout').render();

            field.rootEl.removeChild(field.label);
            field.input.setAttribute('field-type', type);

            if( value ) {
                field.setValue(value);
            }

            return field;

        };

        var types = {
            FIELD: function(cell) {

                var container = document.createElement('div');
                var label = document.createElement('label');
                var btn = document.createElement('button');
                var span = document.createElement('span');
                var spanValue = document.createElement('span');

                container.className = 'column-field';
                label.className = 'preview';

                btn.type = 'button';
                btn.className = 'btn dropdown-toggle btn-default';
                span.className = 'fa fa-caret-down';
                spanValue.className = 'value';

                btn.setAttribute('cell-type',  cell.className);
                spanValue.setAttribute('cell-type',  cell.className);

                btn.appendChild(spanValue);
                btn.appendChild(span);

                container.appendChild(btn);
                container.appendChild(label);

                btn.addEventListener('click', function(e) {
                    scope.btnClickListener(e, spanValue);
                });

                return {
                    rootEl: container
                };
            },
            CHECK: function(cell) {

                var input = getMonetField('CHECKBOX', cell.value);

                return {
                    rootEl: input.input,
                    componentValue: input.input
                };

            },
            TEXT: function(cell) {

                var input = getMonetField('TEXT', cell.value);
                return {
                    rootEl: input.input,
                    componentValue: input.input
                };
            },
            LIST: function(cell) {

                var list = new Monet.UI.Fields.PickListEditable();

                list.setFieldDomains(cell.fieldDomains);
                list.render();

                if ( !cell.editable ) {
                    list.inputValue.disabled = true;
                }

                if(cell.value ) {
                    list.setValue(cell.value);
                }

                var fn = function(e) {
                    var selected = e.target.selectedOptions[0];
                    this.inputValue.value = selected.innerHTML;
                    this.inputValue.setAttribute('valueToSend', selected.value);
                }.bind(list);

                list.setListenerOnChange(fn);

                return {
                    rootEl: list.rootEl,
                    componentValue: list
                };
            },
            BOOLEAN: function(cell) {

                var picklist = getMonetField('PICKLIST', cell.value, {
                    fieldDomains: [
                        {description: Monet.I18n.getResourcesByKey('general.true'), value: "true"},
                        {description: Monet.I18n.getResourcesByKey('general.false'), value: "false"}]
                });

                return {
                    rootEl: picklist.input,
                    componentValue: picklist.input,
                    field: picklist
                };
            },
            RANGE: function(cell) {

                var container = document.createElement('div'),
                    containerNumbers = document.createElement('div'),
                    offset = getMonetField('INTEGER').input,
                    length = getMonetField('INTEGER').input,
                    label = document.createElement('label'),
                    setPreview;

                setPreview = function() {
                    offsetValue = parseInt(offset.value);
                    lengthValue = parseInt(length.value);
                    label.innerHTML = scope.previewData.substring(offsetValue-1, offsetValue + lengthValue-1);
                };

                container.className = 'container-rage';
                containerNumbers.className = 'container-numbers';
                offset.className = 'offset';
                length.className = 'length';
                label.className = 'preview';

                containerNumbers.appendChild(offset);
                containerNumbers.appendChild(length);
                container.appendChild(containerNumbers);
                container.appendChild(label);

                if(cell.values ) {
                    var offsetValue = cell.values[0];
                    var lengthValue = cell.values[1];
                    if(offsetValue && lengthValue) {
                        offset.value = offsetValue;
                        length.value = lengthValue;
                        setPreview();
                    }
                }

                offset.addEventListener('keyup', setPreview);
                length.addEventListener('keyup', setPreview);
                return {
                    rootEl: container
                };
            },
            INTEGER: function(cell) {
                var field = getMonetField('INTEGER', cell.value).input;

                return {
                    rootEl: field,
                    componentValue: field
                };
            },
            DOUBLE: function(cell) {
                var field = getMonetField('LAT_LONG', cell.value).input;

                field.className = 'decimalFieldOld';

                return {
                    rootEl: field,
                    componentValue: field
                };
            }
        };

        this.getFieldByType = function(cell) {
            return (types[cell.type] || types.TEXT)(cell);
        }.bind(this);

        this.getFieldValue = function(input) {

            var type = input.getAttribute('field-type');
            var field = getMonetField(type, input.value);

            return field.getValue();

        };

    }

    return FieldsRender;
}());
